import { createAction } from "redux-actions"
import SignApis from "../apis/SignApis"
import { TOKEN_ID } from "config"

/* action type */
export const IS_LOGIN = "@elefarm-admin/sign/IS_LOGIN"

/* action function */
export const setIsLogin = createAction(IS_LOGIN)

/* action api function */
// 로그인
export const postSignIn = (param) => async (dispatch) => {
  const result = await SignApis.postSignIn(param)
  if (result.code === 0) {
    localStorage.setItem(TOKEN_ID, result.data.accessToken)
    dispatch(setIsLogin(true))
    return true
  } else return false
}

// 로그아웃
export const postSignOut = () => async (dispatch) => {
  const result = await SignApis.postSignOut()
  if (result.code == 0) {
    
    dispatch(setIsLogin(false))
    
    localStorage.removeItem(TOKEN_ID)

    return true
  } else return false
}

// 로그인 상태 체크
export const checkSignStatus = (param) => async (dispatch) => {
  const result = await SignApis.checkSignStatus(param)
  if (result.code == 0) {
    localStorage.setItem(TOKEN_ID, result.data.accessToken)
    dispatch(setIsLogin(true))
    return true
  } else return false
}
// 비밀번호 찾기
export const findPw = (param) => async (dispatch) => {
  const result = await SignApis.findPw(param)
  if (result.code == 0) {
    return true
  } else return false
}
// 회원가입
export const postSignUp = (param) => async (dispatch) => {
  const result = await SignApis.postSignUp(param)
  if (result.code === 0) {
    return true
  } else return false
}
